var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CreditCard component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCreditCard extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.66759 4.64931C2.09503 4.23356 2.67478 4 3.27928 4H20.7207C21.3252 4 21.905 4.23356 22.3324 4.64931C22.7599 5.06505 23 5.62892 23 6.21687V10.0721V17.7831C23 18.3711 22.7599 18.935 22.3324 19.3507C21.905 19.7664 21.3252 20 20.7207 20H3.27928C2.67478 20 2.09503 19.7664 1.66759 19.3507C1.24014 18.935 1 18.3711 1 17.7831V10.0721V6.21687C1 5.62892 1.24014 5.06505 1.66759 4.64931ZM21.6126 6.21687V9.39736H2.38739V6.21687C2.38739 5.9868 2.48135 5.76616 2.64862 5.60347C2.81588 5.44079 3.04273 5.3494 3.27928 5.3494H20.7207C20.9573 5.3494 21.1841 5.44079 21.3514 5.60347C21.5186 5.76616 21.6126 5.9868 21.6126 6.21687ZM21.6126 10.7468H2.38739V17.7831C2.38739 18.0132 2.48135 18.2338 2.64862 18.3965C2.81588 18.5592 3.04274 18.6506 3.27928 18.6506H20.7207C20.9573 18.6506 21.1841 18.5592 21.3514 18.3965C21.5186 18.2338 21.6126 18.0132 21.6126 17.7831V10.7468ZM15.9642 14.7952C15.5811 14.7952 15.2705 15.0973 15.2705 15.4699C15.2705 15.8425 15.5811 16.1446 15.9642 16.1446H18.3426C18.7257 16.1446 19.0363 15.8425 19.0363 15.4699C19.0363 15.0973 18.7257 14.7952 18.3426 14.7952H15.9642Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCreditCard.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCreditCard.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCreditCard.prototype, "size", void 0);
if (customElements.get('cat-icon-credit-card') === undefined) {
    customElements.define('cat-icon-credit-card', BlocksIconCreditCard);
}
